function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftbot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "421px",
    height: "421px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fffefe",
    d: "M -0.5,0.5 C -0.5,0.166667 -0.5,-0.166667 -0.5,-0.5C 139.833,-0.5 280.167,-0.5 420.5,-0.5C 420.5,139.833 420.5,280.167 420.5,420.5C 420.167,420.5 419.833,420.5 419.5,420.5C 279.833,280.167 139.833,140.167 -0.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcb036",
    d: "M -0.5,0.5 C 139.833,140.167 279.833,280.167 419.5,420.5C 279.5,420.5 139.5,420.5 -0.5,420.5C -0.5,280.5 -0.5,140.5 -0.5,0.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftbot);
export default __webpack_public_path__ + "static/media/leftbot.ac9b9a790e182157a3c2186a7a3817af.svg";
export { ForwardRef as ReactComponent };